import { ASSETCHAIN, ASSETCHAIN_TESTNET } from "config/chains";

export function getOracleNetworkParam(chainId: number): "mainnet" | "testnet" | undefined {
  if (chainId === ASSETCHAIN) {
    return "mainnet";
  }

  if (chainId === ASSETCHAIN_TESTNET) {
    return "testnet";
  }

  return undefined;
}

export function appendOracleNetworkParam(searchParams: URLSearchParams, chainId: number) {
  const network = getOracleNetworkParam(chainId);

  if (network) {
    searchParams.set("network", network);
  }

  return searchParams;
}
